export default function a8Gen() {
  return `
        type GenerateContentConfig = {
            name: string
            inputVariables?: Record<string, any>
            inputQuery: any
        }

        declare var a8gen: {
            summarise(data:string | object) => Promise<any>;
            generateContent(config: GenerateContentConfig) => Promise<any>;
        };
    `;
}
